import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";

import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { CUSTOMER_APIs } from "apihandlers/customer";
import { GEO_APIs } from "apihandlers/geography";
import { DateFunctions } from "common/datefunctions";
import AutoComplete from "components/Custom/AutoComplete";

const SalesGrowth = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [states, setStates] = useState([]);

  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const stateRef: any = useRef(null);
  const segmentRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await CUSTOMER_APIs.getCustSalesTypes(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        getStates();
        setLoading(false);
      }
    } catch (error) {
      console.error("getCities:", error);
    }
  };

  const getStates = async () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getStates(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.stateName,
          };
        });
        setStates(list);
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "fromDt",
      name: LABELS.FROM_DATE,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "toDt",
      name: LABELS.TO_DATE,
      width: "14%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "state",
      name: LABELS.STATE,
      width: "40%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "segment",
      name: LABELS.SEGMENT,
      width: "20%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "weightage",
      name: LABELS.WEIGHTAGE,
      width: "30%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageSalesGrowth = () => {
    const fromDt = (
      document.getElementById("fromDt") as HTMLInputElement
    ).value.trim();
    const toDt = (
      document.getElementById("toDt") as HTMLInputElement
    ).value.trim();
    const state = stateRef.current.selectedValue.id;
    const segment = segmentRef.current.selectedValue.id;
    const weightage = (
      document.getElementById("weightage") as HTMLInputElement
    ).value.trim();

    // Validations
    let errors = [];
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!state) {
      errors.push({
        id: "State",
        msg:
          "<span class='bold'>" +
          LABELS.STATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!segment) {
      errors.push({
        id: "Segment",
        msg:
          "<span class='bold'>" +
          LABELS.SEGMENT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!weightage) {
      errors.push({
        id: "weightage",
        msg:
          "<span class='bold'>" +
          LABELS.WEIGHTAGE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (Number(weightage) < 0 || Number(weightage) > 100) {
      errors.push({
        id: "weightage",
        msg:
          "<span class='bold'>" +
          LABELS.WEIGHTAGE +
          "</span> " +
          WARNINGS.MUST_BE_BETWEEN_ZERO_TO_HUNDRED,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      fromDt,
      toDt,
      state,
      segment,
      weightage,
    };
    console.log("args", args);
    setIsSubmit(true);

    //TODO API still in progress
    //POST METHOD
    // CUSTOMER_APIs.manageCustSalesType(args).then((res) => {
    //   setIsSubmit(false);
    //   if (res.status === 200) {
    //     COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
    //     setSelectedRow({});
    //     setManageDialog(false);
    //     reloadGrid();
    //   } else {
    //     COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
    //   }
    // });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.SALES_GROWTH}</li>
        </ul>
        <h4>{TITLES.SALES_GROWTH}</h4>
        <p>{SUB_TITLES.SALES_GROWTH}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.SALES_GROWTH}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.SALES_GROWTH + ": " + selectedRow.salesType
              : "Add New " + LABELS.SALES_GROWTH
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup ">
            <label>{LABELS.FROM_DATE}</label>
            <TxtRow
              type={"date"}
              id="fromDt"
              defaultValue={DateFunctions.getDate(
                "today",
                "from",
                "YYYY-MM-DD"
              )}
            />
          </div>
          <div className="formGroup ">
            <label>{LABELS.TO_DATE}</label>
            <TxtRow
              type={"date"}
              id="toDt"
              defaultValue={DateFunctions.getDate(
                "this month",
                "to",
                "YYYY-MM-DD"
              )}
            />
          </div>
          <div className="formGroup required">
            <label>{LABELS.STATE}</label>
            <span className="red">*</span>
            <AutoComplete
              list={states}
              childRef={stateRef}
              defaultValue={
                selectedRow.stateId
                  ? {
                      id: selectedRow.stateId,
                      label: selectedRow.stateName,
                    }
                  : null
              }
            />
          </div>
          <div className="formGroup required">
            <label>{LABELS.SEGMENT}</label>
            <span className="red">*</span>
            <AutoComplete
              list={states}
              childRef={segmentRef}
              defaultValue={
                selectedRow.stateId
                  ? {
                      id: selectedRow.stateId,
                      label: selectedRow.stateName,
                    }
                  : null
              }
            />
          </div>
          <div className="formGroup ">
            <label>{LABELS.WEIGHTAGE}</label>
            <TxtRow
              type={"text"}
              id={"weightage"}
              defaultValue={selectedRow.id ? selectedRow.weightage : ""}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                className={"btn"}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageSalesGrowth}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(SalesGrowth);
